// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TooltipTrigger-module__Inline__Y9och {
    display: inline;
}

.TooltipTrigger-module__InlineFlex__bOO4_ {
    display: inline-flex;
}

.TooltipTrigger-module__Flex__heC5C {
    display: flex;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Inline": `TooltipTrigger-module__Inline__Y9och`,
	"InlineFlex": `TooltipTrigger-module__InlineFlex__bOO4_`,
	"Flex": `TooltipTrigger-module__Flex__heC5C`
};
export default ___CSS_LOADER_EXPORT___;
